
import axios from 'axios'

const service = axios.create({})

export default service
